import { EM_DASH, formatCents } from '../payFormat';
import type { PayShiftEntry } from '../teacherApi';

/** A shift's pay: the amount, a dash when no rate covers it, or "Salaried". */
export default function ShiftAmount({
  shift,
  salaried,
}: {
  shift: PayShiftEntry;
  salaried: boolean;
}) {
  if (salaried) return <span style={{ fontSize: 11, color: 'var(--nb-subtle)' }}>Salaried</span>;
  if (shift.amountCents === null) {
    return <span title="No rate is configured for this role">{EM_DASH}</span>;
  }
  return <>{formatCents(shift.amountCents)}</>;
}
